import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Imagen } from 'src/app/imagen.model';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { DomToImage } from 'dom-to-image';
import * as process from 'process';


@Component({
  selector: 'app-image-list',
  templateUrl: './image-list.component.html',
  styleUrls: ['./image-list.component.css']

})
export class ImageListComponent implements OnInit {
  filterTerm: string =""
  dirImages: string = "assets/images/"
  isEditable = true;
  linear = false
  images: Imagen[] = []
  imagePreview: any = '';
  defaultImage = 'assets/images/bien-echo.png';
  avatarBrian = 'assets/avatar-brian.webp';
  compartirRedes = 'assets/compartir-redes.png';
  image = 'https://images.unsplash.com/photo-1443890923422-7819ed4101c0?fm=jpg';
  selectedKudoUrl: Imagen = { url: this.defaultImage, orientationText: "left",name:"1" }
  constructor(private _formBuilder: FormBuilder) {
  }

  ngOnInit() {

    require("../../assets/images/listaKudos.json").data.forEach((item: Imagen) => {

      this.images.push({
        orientationText: item.orientationText,
        url: this.dirImages + item.url,
        name: item.name
      })
    })



  }

  selectKudo(imageUrl: Imagen) {
    this.selectedKudoUrl = imageUrl;
  }


  ajustarImagen(nameId: string) {
    let shand = document.getElementById(nameId)
    if (shand != null) { shand.style.backgroundSize = "100% 100%"; }
  }


  generatePreviewPng(idOrigen: string, idDestino: string): void {
    const m = document.getElementById(idOrigen);
    if (m == null) { return; }
    var domtoimage = require('dom-to-image');
    domtoimage.toPng(m)
      .then(function (dataurl: any) {
        let d = document.getElementById(idDestino);
        if (d == null) { return; }
        d.setAttribute('src', dataurl);

        let d2 = document.getElementById('compartirRedes');
        if (d2 == null) { return; }
        d2.setAttribute('src', dataurl);
        d2.style.backgroundSize = "100% 100%";
      });
  }

  downloadAsPng(idOrigen: string): void {
    let idDestino = document.getElementById('shareKudo');
    if (idDestino == null) { return; }
    var link = document.createElement('a');
    link.download = 'my-image-name.png';
    link.setAttribute('href', idDestino.getAttribute('src') + '');
    link.click();

  }

  conditon(item:Imagen): boolean{

    

    return true;
  }

}